// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ok-1";
export var messageSideRight = "_ok-2";
export var subscribeToBackInStockBubbleContainer = "_ok-0";